import { Routes } from '../../../nav/routes'
import { numberToLocalString } from '../../../util/util'

export const txnDetailsMobileParser = (data: any, txnType = Routes.TRANSACTIONS) => {
  const detailsObject: any = {
    paymentMode: data?.payment?.paymentMode?.length > 0 ? data?.payment?.paymentMode : 'NA',
    originalTransactionId: data?.originalTransactionId?.length > 0 ? data?.originalTransactionId : 'NA',
    // utrNumber: data?.bankRefNumber?.length > 0 ? data?.bankRefNumber : 'NA',
    paymentType: data?.payment?.paymentType?.length > 0 ? data?.payment?.paymentType : 'NA',
    amount: numberToLocalString(data?.amount) ?? 'NA',
    status: data?.status?.length > 0 ? data?.status : 'NA',
    isRefundValid: false,
    issRefData: data?.bankRefNumber ?? 'NA',
    invoice: data?.ern ?? 'NA',
    customerName: data?.customer?.name ?? 'NA',
  }

  if (data?.acquirerTerminal?.trim()?.length && data?.acquirerTerminal !== 'NA') {
    detailsObject.acquirerTerminal = data.acquirerTerminal
  }
  if (data?.status && data?.status !== 'SUCCESS') {
    detailsObject.failureMessage = data?.failureMessage
  }
  if (data?.payment?.accountNumber?.trim()?.length) {
    detailsObject.accountNumber = data?.payment?.accountNumber
  }

  const txnAmt = Number(detailsObject?.amount)
  const refundAmt = Number(detailsObject?.amount)

  const getRefundValid = () => {
    const getValid = {
      [Routes.TRANSACTIONS]: detailsObject?.status === 'SUCCESS' && txnAmt > refundAmt,
      [Routes.REFUNDS]: txnAmt > refundAmt,
    }
    return getValid[txnType] ?? false
  }
  const isRefundValid = getRefundValid()
  detailsObject.isRefundValid = isRefundValid
  return detailsObject
}
